/* app/js/src/components/common/splitScreen/splitScreen.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  width: 100%;
  overflow: hidden;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
section:first-child {
  -webkit-transition: width 0.3s linear;
  transition: width 0.3s linear;
  width: 100%;
  -webkit-flex: 1 0 auto;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
}
section:last-child {
  width: 346px;
  max-width: 346px;
  min-width: 346px;
  background-color: #ffffff;
  -webkit-box-shadow: 0 0 5px 0 rgba(35, 47, 58, 0.2);
  -moz-box-shadow: 0 0 5px 0 rgba(35, 47, 58, 0.2);
  box-shadow: 0 0 5px 0 rgba(35, 47, 58, 0.2);
}
section.minimized {
  width: 1%;
}
/*# sourceMappingURL=splitScreen.component.css.map */
